<template>
  <div class="dropdowns-container flex flex-row justify-between items-center gap-1 font-rubik">
    <!-- All Solutions Button -->
    <button
      class="dropdowns-button flex justify-center items-center transition-all nav-link"
      :class="{ active: activeButton === 'solutions' }"
      :style="activeButton === 'solutions' ? { '--active-color': '#3565FC' } : {}"
      @click="setActiveButton('solutions')"
    >
      <span>All Solutions</span>
      <span>
        <img
          :class="{ 'rotate-up': activeButton === 'solutions', 'rotate-down': activeButton !== 'solutions' }"
          src="@/images/header/drop-down-arrow.svg"
          alt="Arrow"
        />
      </span>
    </button>
    
    <!-- Guides Button -->
    <button
      class="dropdowns-button guides-button flex justify-center items-center transition-all nav-link"
      :class="{ active: activeButton === 'guides' }"
      :style="activeButton === 'guides' ? { '--active-color': '#3565FC' } : {}"
      @click="setActiveButton('guides')"
    >
      <span>Guides</span>
      <span>
        <img
          :class="{ 'rotate-up': activeButton === 'guides', 'rotate-down': activeButton !== 'guides' }"
          src="@/images/header/drop-down-arrow.svg"
          alt="Arrow"
        />
      </span>
    </button>
    
    <!-- Resources Button -->
    <button
      class="dropdowns-button flex justify-center items-center transition-all nav-link"
      :class="{ active: activeButton === 'resources' }"
      :style="activeButton === 'resources' ? { '--active-color': '#3565FC' } : {}"
      @click="setActiveButton('resources')"
    >
      <span>Resources</span>
      <span>
        <img
          :class="{ 'rotate-up': activeButton === 'resources', 'rotate-down': activeButton !== 'resources' }"
          src="@/images/header/drop-down-arrow.svg"
          alt="Arrow"
        />
      </span>
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeButton: null
    }
  },
  methods: {
    setActiveButton(button) {
      if (this.activeButton === button) {
        this.activeButton = null
      } else {
        this.activeButton = button
      }
      this.$emit('update:activeButton', this.activeButton)
    }
  }
}
</script>

<style scoped lang="scss">
.dropdowns-container {
  width: 363px;
}

.dropdowns-button {
  background: #F9F8F6;
  width: 100%;
  height: 44px;
  border-radius: 8px;
  padding: 0px 10px;
  span {
    color: #334155;
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: -2%;
  }
}

.guides-button {
  width: 80%;
}

.dropdowns-button.active {
  background-color: #DAE5FF;
  span{
    color: #3565FC;
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    letter-spacing: -2%;
  }
}

.rotate-down {
  transform: rotate(180deg);
}

.rotate-up {
  transform: rotate(0deg);
}

.nav-link {
  position: relative;
}

.nav-link.active::before {
  content: "";
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%);
  width: 48px;
  height: 4px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: var(--active-color, transparent);
  transition: background-color 0.3s ease;
}

.nav-link::after {
  content: "";
  position: absolute;
  bottom: 1px;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  transform-origin: center;
  width: 30px;
  height: 4px;
  background-color: #334155;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  transition: transform 0.3s ease;
}

.nav-link:hover::after {
  transform: translateX(-50%) scaleX(1);
}

/* Prevent Hover Border When Active */
.nav-link.active::after {
  display: none;
}
</style>
